import React from 'react';
import { useTranslation } from 'react-i18next';
import './FloatingFooter.css';

interface FloatingFooterProps {
  selectedCount: number;
  totalCount: number;
  onGenerate: () => void;
  disabled: boolean;
  isPro?: boolean;
}

/**
 * FloatingFooter component - displays a floating footer with a generate button
 */
const FloatingFooter: React.FC<FloatingFooterProps> = ({
  selectedCount,
  totalCount,
  onGenerate,
  disabled,
  isPro = false
}) => {
  const { t } = useTranslation('create');
  return (
    <div className="floating-footer">
      <div className="footer-content">
        <div className="selection-info">
          <span className="selection-count">
            {t('analytics_step.selected_summary', { selected: selectedCount, total: totalCount })}
          </span>
        </div>

        <button
          className={`generate-button${isPro ? ' generate-button-pro' : ''}`}
          onClick={onGenerate}
          disabled={disabled}
        >
          <span className="button-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 5L19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
          {isPro ? (
            <><span className="pro-badge-btn">PRO</span> {t('analytics.generate')} PRO!</>
          ) : (
            t('analytics.generate')
          )}
        </button>
      </div>
    </div>
  );
};

export default FloatingFooter;
